import React from 'react'
import ContactPage from '../../components/contact/contact-page'
import { withApollo } from '../../apollo/apollo'
import TicketingForm from '../../components/contact/ticketing-form'

const Ticketing = () => {
  return (
    <ContactPage title="Ticketing Inquiry">
      <h2>Ticketing Inquiry</h2>
      <TicketingForm />
    </ContactPage>
  )
}

export default Ticketing
